import React from "react";
import { NextPage } from "next";

import CheckLanding from "scenes/CheckLanding";

const Index: NextPage = () => <CheckLanding />;

export default Index;
